var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "to-create" },
    [
      !_vm.nextstep
        ? [
            _c(
              "el-aside",
              {
                staticClass: "aside-left",
                style: { height: _vm.boxHeight },
                attrs: { width: "2.80rem" }
              },
              [
                _c("p", { staticClass: "page-total" }, [
                  _vm._v(
                    "\n        共" +
                      _vm._s(
                        _vm.fileList.length > 0
                          ? _vm.fileList.length + "个文件"
                          : _vm.contractInfo.items + "页"
                      ) +
                      "\n      "
                  )
                ]),
                _c("div", [
                  _vm.fileList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "page-con" },
                        [
                          _vm._l(_vm.fileList, function(file, i) {
                            return [
                              _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "list",
                                  on: {
                                    click: function($event) {
                                      return _vm.chooseFile(file, i)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "right-start"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [_vm._v("此文件设置有签署位置")]
                                      ),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.filePage(file),
                                            expression: "filePage(file)"
                                          }
                                        ],
                                        staticClass: "icon icon-status_sign"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bx",
                                      class: _vm.checkAct === i ? "active" : ""
                                    },
                                    [
                                      _c("div", [
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "pdf"
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/advancedVersion/pdf.png"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "wps"
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/advancedVersion/WPS.png"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "jpg"
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/advancedVersion/JPG.png"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "doc" ||
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "docx"
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/advancedVersion/word.png"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "xlsx" ||
                                        _vm.fileSuffix(
                                          file.fileName || file.name
                                        ) === "xls"
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  "/images/advancedVersion/xlsx.png"
                                              }
                                            })
                                          : _vm._e()
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "title",
                                      attrs: { title: file.fileName }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(file.fileName || file.name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "page-con" },
                        [
                          _vm._l(_vm.contractInfo.items, function(i) {
                            return [
                              _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "list",
                                  class:
                                    _vm.currentInfo.page === i ? "active" : "",
                                  on: {
                                    click: function($event) {
                                      return _vm.getContractDetailByNum(i)
                                    }
                                  }
                                },
                                [
                                  _vm.contractList[i]
                                    ? _c("img", {
                                        attrs: { src: _vm.contractList[i].url }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: "/images/contr_default.jpg",
                                          alt: ""
                                        }
                                      }),
                                  _c("span", [_vm._v(_vm._s(i))])
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                ])
              ]
            ),
            _c(
              "el-main",
              { staticClass: "main-content", style: { height: _vm.boxHeight } },
              [
                _vm.fileList.length == 0
                  ? _c("contract-view", {
                      ref: "contractView",
                      attrs: {
                        "contract-info": _vm.currentInfo,
                        "chapter-list": _vm.chapteJson,
                        items: _vm.contractInfo.items,
                        page: _vm.currentInfo.page,
                        scaleValue: _vm.scaleValue,
                        "show-chapter": true
                      },
                      on: {
                        "update:contractInfo": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:contract-info": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:chapterList": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:chapter-list": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:scaleValue": function($event) {
                          _vm.scaleValue = $event
                        },
                        "update:scale-value": function($event) {
                          _vm.scaleValue = $event
                        },
                        "del-chapte": function($event) {
                          return _vm.delChapteByCindex($event)
                        },
                        "pre-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        "next-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        changeSmallMap: _vm.changeSmallMap,
                        toCurrentPage: _vm.toCurrentPage
                      }
                    })
                  : _c("contract-view-file", {
                      ref: "contractView",
                      attrs: {
                        "contract-info": _vm.currentInfo,
                        "chapter-list": _vm.chapteJson,
                        items: _vm.contractInfoTemporary.items,
                        page: _vm.currentInfo.page,
                        scaleValue: _vm.scaleValue,
                        targetId: _vm.contractInfoTemporary.targetId,
                        "show-chapter": true,
                        "signatory-json": _vm.signatoryJson
                      },
                      on: {
                        "update:contractInfo": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:contract-info": function($event) {
                          _vm.currentInfo = $event
                        },
                        "update:chapterList": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:chapter-list": function($event) {
                          _vm.chapteJson = $event
                        },
                        "update:scaleValue": function($event) {
                          _vm.scaleValue = $event
                        },
                        "update:scale-value": function($event) {
                          _vm.scaleValue = $event
                        },
                        "del-chapte": function($event) {
                          return _vm.delChapteByCindex($event)
                        },
                        "pre-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        "next-page": function($event) {
                          return _vm.getContractDetailByNum($event)
                        },
                        changeSmallMap: _vm.changeSmallMap,
                        toCurrentPage: _vm.toCurrentPage
                      }
                    }),
                _c(
                  "div",
                  {
                    ref: "accessory",
                    staticClass: "text-center accessory-box"
                  },
                  [
                    _vm.contractInfo &&
                    _vm.contractInfo.items &&
                    _vm.contractInfo.items > 1
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "jumpFirst",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(1)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/btn-down.png")
                                }
                              })
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "jumpLast",
                              on: {
                                click: function($event) {
                                  return _vm.goPageAndFixed(
                                    _vm.fileList.length == 0
                                      ? _vm.contractInfo.items
                                      : _vm.contractInfoTemporary.items
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/btn-down.png")
                                }
                              })
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "el-aside",
              {
                staticClass: "aside-right",
                style: { height: _vm.boxHeight },
                attrs: { width: "2.80rem" }
              },
              [
                _c("div", { staticClass: "qs-wrap" }, [
                  _c("p", { staticClass: "m-title" }, [_vm._v("  上传文件")]),
                  _c(
                    "div",
                    { staticClass: "qs-box" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: { padding: "0 25px" },
                          attrs: {
                            action: "#",
                            accept: ".pdf,.doc,.docx,.xls,.xlsx,.wps",
                            multiple: "",
                            limit: 30,
                            "before-upload": _vm.fileOnBeforeUpload,
                            "on-exceed": _vm.fileHandleExceed,
                            "on-error": _vm.fileOnError,
                            "show-file-list": false
                          }
                        },
                        [
                          _vm._t("default", function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "upload-content" },
                                [
                                  _c(
                                    "el-button",
                                    { staticClass: "btn danger-btn mybtn" },
                                    [_vm._v("点击上传")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "el-upload__tip t3" },
                                    [
                                      _vm._v(
                                        "\n                  上传 pdf、doc、docx、xls、xlsx 、wps格式文件\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "list-signers" }, [
                  _c("p", { staticClass: "t2" }, [_vm._v("  设置签章位置")]),
                  _c("p", { staticClass: "t3" }, [
                    _vm._v("在签署页，拖动签章位置到需要盖章的地方")
                  ]),
                  _c(
                    "div",
                    { staticClass: "qy-wrap" },
                    [
                      _vm.signatoryJson
                        ? _vm._l(_vm.signatoryJson, function(item, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                item.signOwner === "批量签署方"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          key: item.signOwner,
                                          staticStyle: { "margin-top": "18px" }
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "user-show" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-error del-signer",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.delSignList(item)
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row-wrap" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dragbox",
                                                  attrs: { draggable: "true" },
                                                  on: {
                                                    dragend: function($event) {
                                                      return _vm.dragQZEnd(
                                                        $event,
                                                        item.signOwner
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticClass: "normal-btn",
                                                      attrs: {
                                                        draggable: "true",
                                                        size: "small",
                                                        title: "点击或拖拽"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleAddChapter(
                                                            item.signOwner
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "rt",
                                                          staticStyle: {
                                                            width: "90px"
                                                          }
                                                        },
                                                        [_vm._v("批量签署方")]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(item.signOwner) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "el-button-group",
                                        {
                                          key: item.signOwner,
                                          staticClass: "btn-group"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "user-show" },
                                            [
                                              item.signatoryFullName
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-ellipsis",
                                                      attrs: {
                                                        title:
                                                          item.signatoryFullName
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.signatoryFullName
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row-wrap" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dragbox",
                                                  attrs: { draggable: "true" },
                                                  on: {
                                                    dragend: function($event) {
                                                      return _vm.dragQZEnd(
                                                        $event,
                                                        item.signOwner,
                                                        item.signatoryFullName
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      ref: "step3",
                                                      refInFor: true,
                                                      staticClass: "normal-btn",
                                                      attrs: {
                                                        size: "small",
                                                        draggable: "true",
                                                        type: "danger",
                                                        title: "点击或拖拽"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleAddChapter(
                                                            item.signOwner,
                                                            item.signatoryFullName
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "rt" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.signOwner
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "设置签章位置\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          })
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "div",
                    [
                      _c("p", { staticClass: "t2" }, [_vm._v("  位置信息")]),
                      _vm._l(_vm.chapteJson, function(item, i) {
                        return _c(
                          "el-card",
                          { key: i, staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header"
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v(_vm._s(item.signOwner))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      padding: "3px 0",
                                      "font-size": "12px"
                                    },
                                    attrs: { type: "text" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s("在第 " + (item.page + 1) + " 页")
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s("X坐标 " + item.offsetX) +
                                  "\n            "
                              )
                            ]),
                            _c("div", [
                              _vm._v(
                                "\n              " +
                                  _vm._s("Y坐标 " + item.offsetY) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm.guideStep
        ? _c("div", { staticClass: "apply-guide" }, [
            _c(
              "div",
              { ref: "guideBox", staticClass: "box" },
              [
                _vm.guideStep !== "step5"
                  ? _c(
                      "div",
                      {
                        ref: "tooltip",
                        staticClass: "tooltip",
                        class:
                          _vm.guideStep === "step4"
                            ? "tooltip-top"
                            : "tooltip-bottom"
                      },
                      [
                        _vm.guideStep === "step1"
                          ? [
                              _c("div", { staticClass: "tooltip-text" }, [
                                _c("span", [_vm._v("1")]),
                                _vm._v("点击添加签署方")
                              ]),
                              _c("div", { staticClass: "tooltiop-btns" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: { click: _vm.guideApplyCancel }
                                  },
                                  [_vm._v("关闭引导")]
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.guideApply("step2")
                                      }
                                    }
                                  },
                                  [_vm._v("下一步")]
                                )
                              ]),
                              _c("div", {
                                staticClass: "tooltip-arrow",
                                staticStyle: { left: "65%" }
                              })
                            ]
                          : _vm._e(),
                        _vm.guideStep === "step2"
                          ? [
                              _c("div", { staticClass: "tooltip-text" }, [
                                _c("span", [_vm._v("2")]),
                                _vm._v("点击填写签署方信息")
                              ]),
                              _c("div", { staticClass: "tooltiop-btns" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: { click: _vm.guideApplyCancel }
                                  },
                                  [_vm._v("关闭引导")]
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.guideApply("step3")
                                      }
                                    }
                                  },
                                  [_vm._v("下一步")]
                                )
                              ]),
                              _c("div", {
                                staticClass: "tooltip-arrow",
                                staticStyle: { left: "92%" }
                              })
                            ]
                          : _vm._e(),
                        _vm.guideStep === "step3"
                          ? [
                              _c("div", { staticClass: "tooltip-text" }, [
                                _c("span", [_vm._v("3")]),
                                _vm._v("点击签署方设置固定签章位置\n          ")
                              ]),
                              _c("div", { staticClass: "tooltiop-btns" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: { click: _vm.guideApplyCancel }
                                  },
                                  [_vm._v("关闭引导")]
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.guideApply("step4")
                                      }
                                    }
                                  },
                                  [_vm._v("下一步")]
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "tooltip-arrow",
                                  staticStyle: { left: "75%" }
                                },
                                [_vm._v("+")]
                              )
                            ]
                          : _vm._e(),
                        _vm.guideStep === "step4"
                          ? [
                              _c("div", { staticClass: "tooltip-text" }, [
                                _c("span", [_vm._v("4")]),
                                _vm._v("点击添加附件")
                              ]),
                              _c("div", { staticClass: "tooltiop-btns" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void (0)" },
                                    on: { click: _vm.guideApplyCancel }
                                  },
                                  [_vm._v("完成")]
                                )
                              ]),
                              _c("div", {
                                staticClass: "tooltip-arrow",
                                staticStyle: { left: "25%" }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.guideStep === "step5"
                  ? [
                      _c(
                        "div",
                        {
                          ref: "tooltip",
                          staticClass: "tooltip tooltip-bottom",
                          staticStyle: { left: "10px", top: "60px" }
                        },
                        [
                          _c("div", { staticClass: "tooltip-text" }, [
                            _c("span", [_vm._v("1")]),
                            _vm._v(
                              "顺序签名选择，可以拖动签署方进行签名排序\n          "
                            )
                          ]),
                          _c("div", { staticClass: "tooltiop-btns" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void (0)" },
                                on: { click: _vm.guideApplyCancel }
                              },
                              [_vm._v("完成")]
                            )
                          ]),
                          _c("div", {
                            staticClass: "tooltip-arrow",
                            staticStyle: { left: "25%" }
                          })
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c566b052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c566b052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/applySign/toCreateDemo.vue
// module id = aQi9
// module chunks = 35